import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpinnerComponent, InterpolatedTranslatePipe } from '@web/common';
import { SIGNING_RETURN_MESSAGE, SIGNING_STATUS_PARAM, SigningReturnMessage, SigningReturnStatus } from '@web/service';

/**
 * Where Signicat sends the popup after a Sign API v2 signing. Reports the outcome to the app window
 * that opened it and closes; the text only shows if the browser refuses to close the window.
 */
@Component({
  selector: 'cas-signing-return',
  template: `
    <div class="d-flex flex-column align-items-center gap-3 p-5 text-center">
      <cas-spinner size="lg" />
      <span>{{ 'cas.signingReturnCloseWindow' | translate }}</span>
    </div>
  `,
  imports: [SpinnerComponent, InterpolatedTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SigningReturn {
  constructor() {
    const status = inject(ActivatedRoute).snapshot.queryParamMap.get(SIGNING_STATUS_PARAM);
    const message: SigningReturnMessage = {
      type: SIGNING_RETURN_MESSAGE,
      status: (status ?? 'error') as SigningReturnStatus,
    };
    window.opener?.postMessage(message, window.location.origin);
    window.close();
  }
}
